// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ul-class[data-v-78dd1e9a]{margin:0;padding-left:15px}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Customers/BusinessIncidents/Index.vue"],"names":[],"mappings":"AACA,2BACI,QAAA,CACA,iBAAA","sourcesContent":["\n.ul-class{\n    margin: 0;\n    padding-left: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
